import { type UseQueryResult, useQuery } from 'react-query';
import {
  PlanService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Plan_PlanGrantDocumentResponse,
} from '../../services/wealthlane-award-services';

const useGetPlanGrantDocumentDetailById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Plan_PlanGrantDocumentResponse | undefined,
  unknown
> => {
  const planGrantDocumentDetailById = useQuery(['getPlanGrantDocumentDetailById', id], async () => {
    if (id) {
      return await handleRequest(PlanService.getApiAwardApiAppPlanPlanGrantDocumentDetailById(id));
    }
  });

  return planGrantDocumentDetailById;
};

export default useGetPlanGrantDocumentDetailById;
